export default payload => {
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push(payload);
  } else {
    if (env === 'dev') {
      console.warn('############################');
      console.warn('##   GTM dataLayer push   ##');
      console.warn('############################');
      console.warn(payload);
      console.warn('############################');
      console.warn('############################');
    }
  }
};
